import { useEffect, useState, useCallback } from 'react';
import { Row, Checkbox, Col, Button } from 'antd';

const CameraPopupPage = () => {
   
   const handleSendImage = (message) => {
      window.opener && window.opener.postMessage(message, '*');
   };

   return (
      <Row justify='center mt-80'>
         <Col>
            <Button onClick={handleSendImage}>
               Capturar
            </Button>
         </Col>
      </Row>
   );
};

export default CameraPopupPage;